import type { ReactNode } from "react";

export function StatusChip({ tone = "neutral", children }: { tone?: "success" | "warning" | "error" | "info" | "neutral"; children: ReactNode }) {
  return <span className={`status-chip status-chip--${tone}`}><span aria-hidden="true" className="status-chip__shape" />{children}</span>;
}
